<div class="site-request-modal">
    <div class="modal fade show" style="display:block;" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- <button type="button" class="btn-close" (click)="closePopupEmitter.emit()"></button> -->
                    <button type="button" class="btn-close" (click)="closeModal()"></button>
                </div>

                <div class="modal-body popup-content">
                    <p class="popup-message">
                        <b>Do you have questions about our reports?</b>
                    </p>
                    <p>Please fill the form to request a call form us</p>
                    <form [formGroup]="callForm" (ngSubmit)="onSubmit()">

                        <div class="test">
                            <label for="name">Your Name*</label>
                            <input type="text" class="form-control" formControlName="name" name="name"
                                placeholder="Enter Your Name*">
                            @if(callForm.get('name')?.invalid &&
                            (callForm.get('name')?.dirty || callForm.get('name')?.touched)) {

                            @if(callForm.get('name')?.errors?.['required']) {
                            <p class="error">Name is required</p>
                            }
                            }
                        </div>

                        <div class="test">
                            <label for="company">Your Company Name</label>
                            <input type="text" class="form-control" formControlName="company_name" name="company_name"
                                placeholder="Enter Your Company">
                        </div>


                        <div class="test">
                            <label for="email">Your Email*</label>
                            <input type="email" class="form-control" formControlName="email" name="email"
                                placeholder="Enter Your Email*">
                            @if(callForm.get('email')?.invalid &&
                            (callForm.get('email')?.dirty || callForm.get('email')?.touched)) {

                            @if(callForm.get('email')?.errors?.['required']) {
                            <p class="error">Email is required</p>
                            }
                            @if(callForm.get('email')?.errors?.['email']) {
                            <p class="error">Please enter a valid email</p>
                            }
                            }
                        </div>

                        <div class="test">
                            <label for="phone">Your Phone Number*</label>

                            <input type="tel" class="form-control" formControlName="phone" name="phone"
                                placeholder="Enter Your Phone Number" appIntlTelInput [itiOptions]="itiOptions">
                            @if(callForm.get('phone')?.invalid &&
                            (callForm.get('phone')?.dirty || callForm.get('phone')?.touched)) {

                            @if(callForm.get('phone')?.errors?.['required']) {
                            <p class="error">Phone is required</p>
                            }
                            }
                        </div>

                        <div class="test">
                            <label for="convenient_time">Convenient Call Time*</label>
                            <input type="time" class="form-control" formControlName="convenient_time" name="convenient_time"
                                placeholder="Convenient Call Time*">
                            @if(callForm.get('convenient_time')?.invalid &&
                            (callForm.get('convenient_time')?.dirty || callForm.get('convenient_time')?.touched)) {

                            @if(callForm.get('convenient_time')?.errors?.['required']) {
                            <p class="error">Convenient Call Time is required</p>
                            }
                            }
                        </div>

                        <div class="test">
                            <label for="message">Message</label>
                            <textarea class="form-control" formControlName="message" name="message"
                                placeholder="Enter Message"></textarea>
                        </div>

                        <p class="popup-message">Your information may be used in accordance with the Social Network
                            Finder <a routerLink="/privacy-policy"> Privacy Policy</a> </p>
                        @if(successMessage()) {
                        <p class="success-message">{{ successMessage() }}</p>
                        }
                        @if(errorMessage()) {
                        <p class="error">{{ errorMessage() }}</p>
                        }
                        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
                            {{ isSubmitting() ? 'Submitting...' : 'Submit Request' }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
